<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.addProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.productImg')"
            @selectImage="selectImage"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- <BaseImageUploadInput @file-selected="handleFileSelected" @file-removed="handleFileRemoved" /> -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codenameEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProd')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProdEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.product_price')"
            v-model.trim="data.price"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.quantity')"
            v-model.trim="data.quantity"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.expire_date_from')"
            v-model.trim="data.expire_date_from"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.expire_date_to')"
            v-model.trim="data.expire_date_to"
            required
          />
          <base-select-input
            col="6"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.section')"
            v-model.trim="data.section"
            required
          />
          <base-select-input
            col="5"
            :optionsList="pranches"
            multiple
            :placeholder="$t('PLACEHOLDERS.pranches')"
            v-model.trim="data.pranches"
            required
          />
          <a-tooltip
            v-if="pranches.length == 0"
            class="col-1"
            placement="bottom"
          >
            <template slot="title">
              <span>{{ $t("PLACEHOLDERS.add_pranch") }}</span>
            </template>
            <button type="button" class="btn_edit" @click="addBranches()">
              <i class="fas fa-code-branch"></i>
            </button>
          </a-tooltip>
          <!-- End:: Name Input -->

          <v-container>
            <v-row v-for="(box, index) in boxes" :key="index" align="center">
              <v-col cols="12" class="text-right">
                <v-btn icon color="primary" @click="addBox">
                  <i class="fas fa-plus"></i>
                </v-btn>

                <v-btn
                  icon
                  color="red"
                  v-if="boxes.length > 1"
                  @click="removeBox(index)"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
              </v-col>
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.condiction_ar')"
                v-model="box.condiction_ar"
                required
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.condiction_en')"
                v-model="box.condiction_en"
                required
              />
              <v-divider class="my-4"></v-divider>
            </v-row>
          </v-container>

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "CreateProduct",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        price: null,
        quantity: null,
        expire_date_from: null,
        expire_date_to: null,
        section: null,
        pranches: null,
        active: null,
      },
      boxes: [
        {
          condiction_ar: "",
          condiction_en: "",
        },
      ],
      // End:: Data Collection To Send
      pranches: [],
      categories: [],
      subCats: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    mostPaids() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: true,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: false,
        },
      ];
    },
  },

  methods: {
    addBox() {
      this.boxes.push({
        condiction_ar: "",
        condiction_en: "",
      });
    },
    removeBox(index) {
      if (this.boxes.length > 1) {
        this.boxes.splice(index, 1);
      }
    },
    async getCats() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.categories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getPranches() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `branches?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.pranches = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    addBranches() {
      this.$router.push({ path: `/branches/create` });
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.name = this.data.name.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.name) {
        REQUEST_DATA.append("name[ar]", this.data.name);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.descProd) {
        REQUEST_DATA.append("description[ar]", this.data.descProd);
      }
      if (this.data.descProdEn) {
        REQUEST_DATA.append("description[en]", this.data.descProdEn);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      if (this.data.quantity) {
        REQUEST_DATA.append("quantity", this.data.quantity);
      }
      if (this.data.section) {
        REQUEST_DATA.append("category_id", this.data.section?.id);
      }
      if (this.data.expire_date_from) {
        REQUEST_DATA.append("start_date", this.data.expire_date_from);
      }
      if (this.data.expire_date_to) {
        REQUEST_DATA.append("end_date", this.data.expire_date_to);
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      this.data.pranches?.map((ele) => {
        REQUEST_DATA.append("branches[]", ele.id);
      });
      this.boxes?.map((ele) => {
        if (ele.condiction_ar) {
          REQUEST_DATA.append("usage_conditions[ar][]", ele.condiction_ar);
        }
        if (ele.condiction_en) {
          REQUEST_DATA.append("usage_conditions[en][]", ele.condiction_en);
        }
      });

      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `products`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/products/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    this.getCats();
    this.getPranches();
  },
};
</script>
